import React from 'react';
import classnames from 'classnames';
import type { LayoutItemProps } from './LayoutTypes';

const LayoutItems: React.FC<LayoutItemProps & React.PropsWithChildren> = ({ itemClassNames, children }) => {
    if (Array.isArray(children)) {
        return (
            <>
                {children.map((child, key) => (
                    <div key={`sgw-layout-item-${key + 1}`} className={classnames('sgw-layout-item', itemClassNames)}>
                        {child}
                    </div>
                ))}
            </>
        );
    }
    return typeof children !== 'undefined' ? (
        <div className={classnames('sgw-layout-item', itemClassNames)}>{children}</div>
    ) : null;
};

export default LayoutItems;
